import { getTitleAndDescription } from '@components/OpportunityListing/utils/helper';
import { Image, Text } from '@ui/atoms';
import React from 'react';

const OpportunityListingEmptyState = ({
    isActiveOpportunities,
    hasFilters,
    type,
}) => {
    const { title, description } = getTitleAndDescription(
        isActiveOpportunities,
        hasFilters,
        type
    );
    return (
        <div className="relative shadow-empty-state w-[328px] md:w-[555px] bg-basicWhite rounded-xl border border-secondary-200 overflow-hidden">
            <Image
                src="/images/pending-order-desktop-wave.svg"
                alt="wave"
                className="h-full absolute -top-[30px] md:-top-[30px] -right-[50px] md:-right-[200px] rotate-12"
            />
            <div className="relative z-10 m-4 md:my-[38px] md:ml-6 mr-3 space-y-3 md:space-y-2 w-2/3 md:w-[70%]">
                <Text
                    className="h7-semibold md:h5-semibold text-primary-500"
                    content={title}
                />
                <Text
                    className="p6-regular md:p4-regular text-primary-500"
                    content={description}
                />
            </div>
            <Image
                src="/images/kyc-banner/kyc-banner-mascot.webp"
                alt="jiraaf-mascot"
                className="absolute bottom-0 w-16 md:w-24 right-6"
            />
        </div>
    );
};

export default OpportunityListingEmptyState;
